const GeocodeProvider = Object.freeze({
  //Google: 'google',
  ClickGo: 'clickgo',
  Nominatim: 'nominatim'
})

export default GeocodeProvider



// WEBPACK FOOTER //
// ./src/services/geocoding/geocodeProvider.js